import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const ArrowRight: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M0 12H22.5M22.5 12L14.5 20M22.5 12L14.5 4'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default ArrowRight
